<template>
  <article class="event-teaser">
    <header class="event-teaser__header">
      <h3 class="event-teaser__title">
        <!-- eslint-disable vue/no-v-html -->
        <a
          class="event-teaser__link"
          :href="url"
          v-html="titleList"
        />
        <!-- eslint-enable vue/no-v-html -->
      </h3>
    </header>

    <p class="event-teaser__description">
      <span><b>Art:</b> {{ mappedEventType }}</span>
      <span><b>Termin:</b> {{ date }}</span>
      <span v-if="digital"><b>Ort:</b> Digital</span>
      <span v-if="!digital"><b>Ort:</b> {{ city }}</span>
      <span v-if="!digital"><b>Bundesland:</b> {{ state }}</span>
      <a
        class="event-teaser__more"
        :href="url"
      >
        Details
      </a>
    </p>
    <hr class="event-teaser__spacer">
  </article>
</template>

<script>
import mapEventType from '../functions/map-event-type'

export default {
  name: 'CEventTeaser',

  props: {
    simGames: {
      type: Array,
      required: true
    },
    eventType: {
      type: String,
      required: true
    },
    eventDays: {
      type: Array,
      required: true
    },
    city: {
      type: String,
      required: true
    },
    state: {
      type: String,
      required: true
    },
    digital: {
      type: Boolean,
      required: true
    },
    url: {
      type: String,
      required: true
    }
  },

  computed: {
    titleList () {
      return this.simGames.join(', ')
    },
    date () {
      let dateString = ''
      if (this.eventDays.length >= 1) {
        const date = new Date(this.eventDays[0].date)
        // WTF!!!!!
        dateString += date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear()
      }
      if (this.eventDays.length >= 2) {
        dateString += ' (mehrtägig)'
      }
      return dateString
    },
    mappedEventType () {
      return mapEventType(this.eventType)
    }
  }
}
</script>
